import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "@libs/zapi-ui/shadcn";
import { AppButton, Typography } from "@libs/zapi-ui/custom";

type TGenerationNotificationModalProps = {
  open: boolean;
  onClose: () => void;
};

export function GenerationNotificationModal(props: TGenerationNotificationModalProps) {
  const { open, onClose } = props;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            <Typography variant="heading4" color="zinc900">
              Generation in Progress
            </Typography>
          </DialogTitle>
          <DialogDescription>
            <Typography variant="body2" color="zinc500">
              Generation will take 10-30 minutes. You can safely navigate from this page and come back later.
            </Typography>
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <AppButton appearance="contained" color="zinc950" onClick={onClose}>
            <Typography variant="label2" color="zinc100">
              Got it
            </Typography>
          </AppButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
